import type { AxiosResponse } from 'axios';
import { downloadBlobInBrowser, getFilenameFromContentDisposition } from './browserBlobDownload';

/** Second type param is Axios request config data `D`, not response metadata — use `unknown`. */
type ExcelDownloadAxiosResponse = AxiosResponse<Blob | File, unknown>;

/**
 * Triggers a browser download for an Excel (or CSV) file from an Axios response with `responseType: 'blob'`.
 * Resource entries should set `sideEffectGet: true` when this is used from GET routes so `useGet`
 * does not retain large bodies in cache; prefer `noddiAsync.useDownload` for download-only actions.
 */
export function downloadToExcel(res: ExcelDownloadAxiosResponse): Blob | File {
  const filename = getFilenameFromContentDisposition(res.headers['content-disposition'], 'download.xlsx');
  downloadBlobInBrowser(res.data, filename);
  return res.data;
}
